export type RoleDto = {
  description: string
  id: number
  rolename: string
  sortIndex: number
}

export type RoleWithPermissions = RoleDto & {
  permissions: string[]
}

export type CreateRoleDto = {
  rolename: string
  description: string
  removed: boolean
}

export type PemissionDto = {
  description: string
  id: number
  key: string
  name: string
}

export const canRemoveRole = (roleName: string | undefined) => {
  if (!roleName) return false

  const rolesThatCannotBeRemoved = ['Accounting', 'Administrator', 'Estimator', 'Foreman', 'Sales', 'Scheduler']
  return !rolesThatCannotBeRemoved.includes(roleName)
}